import { ArrowRight, BookOpen, Clock } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CATEGORIES, CATEGORY_LABELS, articles, type Article, type ArticleCategory } from "../content/articles";
import { formatDateShort } from "../lib/money";

/**
 * Обложка статьи: широкая 16:9, как медиа-блок новостной карточки в
 * peptide-shop. Фото в ТЗ нет — градиент по категории и иконка.
 */
export function ArticleCover({ article }: { article: Article }) {
  return (
    <div className={`news-card__media cover--${article.category}`}>
      <BookOpen size={32} strokeWidth={1.4} aria-hidden />
    </div>
  );
}

/**
 * Экран 11 ТЗ — «Полезное»: категории и карточки статей.
 * Карточка повторяет новостную из peptide-shop: обложка во всю ширину,
 * дата-пилюля, заголовок, лид и строка «Читать полностью».
 */
export function ArticlesScreen() {
  const navigate = useNavigate();
  const [category, setCategory] = useState<ArticleCategory | null>(null);
  const items = category ? articles.filter((article) => article.category === category) : articles;

  return (
    <div className="screen">
      <h1 className="screen__title">Полезное</h1>
      <p className="screen__subtitle">О тирзепатиде, снижении веса, питании и образе жизни.</p>

      <div className="chips">
        <button type="button" className={`chip${category === null ? " chip--active" : ""}`} onClick={() => setCategory(null)}>
          Все
        </button>
        {CATEGORIES.map((item) => (
          <button
            key={item}
            type="button"
            className={`chip${category === item ? " chip--active" : ""}`}
            onClick={() => setCategory(item)}
          >
            {CATEGORY_LABELS[item]}
          </button>
        ))}
      </div>

      {items.length === 0 && <div className="state">В этой категории пока нет статей</div>}

      {items.map((article) => (
        <button key={article.slug} type="button" className="news-card" onClick={() => navigate(`/articles/${article.slug}`)}>
          <ArticleCover article={article} />

          <div className="news-card__body">
            <span className="news-card__date">
              <Clock size={13} strokeWidth={2.4} aria-hidden />
              {formatDateShort(article.date)}
            </span>

            <div className="news-card__title">{article.title}</div>
            <div className="news-card__excerpt">{article.excerpt}</div>

            <div className="news-card__footer">
              <span className="news-card__more">
                Читать полностью
                <ArrowRight size={16} strokeWidth={2.2} aria-hidden />
              </span>
              <span className="news-card__meta">
                {CATEGORY_LABELS[article.category]} · {article.readingMin} мин.
              </span>
            </div>
          </div>
        </button>
      ))}
    </div>
  );
}
